import $ from 'jquery'

/*************** Menu ***************/
var tab_anchors = $('#mega_menu_tabs a')
var tabby = $('#mega_menu_tabs li')

$(tab_anchors).on('mouseover', function (event) {
	event.preventDefault()

	var item = $(this).data()
	var mega_menu_tab_items = $('#mega_menu_tab_items')

	if (!$(this).hasClass('active')) {
		mega_menu_tab_items.find('.items').hide() //find items then hides them within mega menu items
		$(tab_anchors).removeClass('active') //mega menu tabs anchors have their class removed
	}

	mega_menu_tab_items.find('.' + item.id).toggle()

	$(this).addClass('active')
})

$('#mega_menu_tab_items .items').on('mouseleave', function () {
	var mega_menu_tab_items = $('#mega_menu_tab_items')

	mega_menu_tab_items.find('.items').hide() //find items then hides them within mega menu items
	$(tab_anchors).removeClass('active') //mega menu tabs anchors have their class removed
})

if (tabby.hasClass('normal-click')) {
	$('.normal-click a').off('click mouseover')
	$('.normal-click a').addClass('normal-link')
}

$('#otherLogins').on('click', function () {
	$('#OtherLoginBox').slideToggle('slow')
	$('#primary_login_form').removeClass('first-united-login-form--show')
	$('#primary_login_button').removeClass('clicked').trigger('focus')
})

/*************** Show login form ***************/
$('#primary_login_button').on('click', function (event) {
	event.preventDefault()

	$(this).toggleClass('clicked')
	$('#primary_login_form').toggleClass('first-united-login-form--show')
	$('#OtherLoginBox').slideUp('slow')

	if ($(this).hasClass('clicked')) {
		$('#user_id').trigger('focus')
	} else {
		$(this).trigger('focus')
	}
})

$(document).on('keyup', function (event) {
	if (event.key == 'Escape') {
		if ($('#primary_login_button').hasClass('clicked')) {
			$('#primary_login_form').removeClass('first-united-login-form--show')
			$('#primary_login_button').removeClass('clicked').trigger('focus')
		}
	}
})
